import PlanningPage from './pages/Builder/index.jsx';
import IndexApp from './pages/IndexApp.jsx';

export const Layout = IndexApp;
export const BuyingPlan = PlanningPage;
